module.exports = __webpack_public_path__ + "img/winning_numbers.d75f19df.png";